import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import RankingSection from './components/RankingSection';
import LatestUpdates from './components/LatestUpdates';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "女神漫画 - 下拉式弹窗翻页阅读体验，免费全集漫画在线阅读",
  "description": "女神漫画支持下拉式、弹窗、翻页等多种阅读模式，提供免费全集漫画在线阅读，涵盖韩漫、日漫、国漫推荐，并支持收藏追更热门漫画。",
  "url": "https://nvshenmanhua.com",
  "inLanguage": "zh-Hans",
  "isPartOf": {
    "@type": "WebSite",
    "name": "女神漫画",
    "url": "https://nvshenmanhua.com"
  },
  "about": {
    "@type": "Thing",
    "name": "漫画在线阅读",
    "description": "免费全集漫画在线阅读平台"
  }
};

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <>
      <SEOHead
        title="女神漫画 - 下拉式弹窗翻页阅读体验，免费全集漫画在线阅读 | 韩漫日漫国漫推荐"
        description="女神漫画支持下拉式、弹窗、翻页等多种阅读模式，提供免费全集漫画在线阅读，涵盖韩漫、日漫、国漫推荐，并支持收藏追更热门漫画。海量高清漫画，每日更新。"
        keywords="女神漫画,下拉式阅读,弹窗阅读,翻页阅读,免费全集,漫画在线阅读,韩漫,日漫,国漫,收藏,追更,漫画大全"
        canonicalUrl="https://nvshenmanhua.com"
        schemaJson={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryTabs
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />
        <RankingSection />
        <LatestUpdates />

        <section className="py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              多种阅读模式，随心选择
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto mb-10">
              女神漫画支持<strong>下拉式</strong>、<strong>弹窗</strong>、<strong>翻页</strong>等多种阅读模式，满足不同读者的阅读习惯，让每一页漫画都栩栩如生。
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-8 rounded-xl bg-background-50 hover:bg-background-100 transition-colors text-left">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-arrow-down-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">下拉式阅读</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  流畅的下拉滚动阅读体验，手指轻轻滑动即可连续阅读，适合手机端和网页端，让阅读更加轻松自如。
                </p>
              </div>
              <div className="p-8 rounded-xl bg-background-50 hover:bg-background-100 transition-colors text-left">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                  <i className="ri-window-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">弹窗阅读</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  沉浸式弹窗阅读模式，全屏显示漫画内容，去除干扰元素，专注于画面本身，带来影院级的视觉享受。
                </p>
              </div>
              <div className="p-8 rounded-xl bg-background-50 hover:bg-background-100 transition-colors text-left">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4">
                  <i className="ri-book-open-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">翻页阅读</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  经典翻页阅读模式，模拟纸质漫画翻页效果，左右滑动即可翻页，还原最真实的漫画阅读体验。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto bg-gradient-to-r from-primary-500 to-primary-600 rounded-2xl p-10 md:p-14 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              随时随地，畅享漫画阅读
            </h2>
            <p className="text-background-50/80 max-w-xl mx-auto mb-8">
              海量高清漫画资源，每日更新，收藏追更不迷路。女神漫画，你的随身漫画图书馆。
            </p>
            <a
              href="/category/all"
              className="inline-flex px-8 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              立即开始阅读
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}